/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import BplsChartComponent from '../components/BplsChartComponent';

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });

const payload = {
  period: 'MONTHLY',
  date_from: moment().startOf('year').format('YYYY-MM-DD'),
  date_to: moment().endOf('year').format('YYYY-MM-DD'),
  permit_type: 'Electronic Business Permit and Licensing System (eBPLS)',
};

function BplsDashboardChartContainerE2E({
  graphStats,
  getGraphStatsE2E,
}) {
  const [isLoading, setIsLoading] = useState(true);

  const handleOnSubmit = (data) => {
    const args = {
      ...data,
      module_type: 'BPLS',
      permit_type: 'Electronic Business Permit and Licensing System (eBPLS)',
    }
    getGraphStatsE2E(args);
  };

  useEffect(() => {
    getGraphStatsE2E(payload);
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Statistics</div>
        </div>
        <div className="stat-filters">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <BplsChartComponent
            chartData={graphStats}
          />
        </div>
        <div className="legends-wrapper-v2 area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(c.EBPLS)}
          </div>
        </div>
      </div>
    </div>
  );
}

BplsDashboardChartContainerE2E.propTypes = {
  graphStats: PropTypes.instanceOf(Object).isRequired,
  getGraphStatsE2E: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS_E2E}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(BplsDashboardChartContainerE2E);
